module.exports = new __parcel__URL__("exercise8.0ea90fd6.png").toString();